// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".external{padding:12px 0 12px 0!important}.pop_small ul{margin:0 -12px;min-height:26px}.pop_small li{min-height:26px;padding-right:10px;font-size:12px;line-height:26px;cursor:pointer;color:#3e3e3c}.pop_small li span{padding-left:10px}.pop_small li:hover{background:#f3f2f2;color:#006dcc}.type{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.typetree{width:80%;margin-left:10%}.conversation{background-color:#fff}.conversationMargin{margin-top:20px}", ""]);
// Exports
module.exports = exports;
